import React, {
    Dispatch,
    LegacyRef,
    ReactNode,
    SetStateAction,
    useEffect,
    useRef,
  } from 'react'
  import { Icon } from '../Icon'
  
  export interface MenuItemInterface {
    label?: string
    onClick?: () => void
    icon: string
    iconColor?: string
    textColor?: string
    display?:boolean
  }
  
  interface MenuProps {
    isOpen?: boolean
    items: MenuItemInterface[]
    children: ReactNode
    type?: string
    isOpenMenus?: boolean[]
    setIsOpenMenu?: Dispatch<SetStateAction<boolean[]>> | undefined
    wrapperRefScrollMenu: LegacyRef<HTMLDivElement> | undefined
  }
  
  const DashboardMenu: React.FC<MenuProps> = ({
    isOpen,
    items,
    children,
    type,
    isOpenMenus,
    setIsOpenMenu,
    wrapperRefScrollMenu,
  }) => {
    const wrapperRefMenu = useRef<HTMLDivElement>(null)
  
    useEffect(() => {
      const handleOutsideClick = (event: MouseEvent) => {
        // Check if the click is outside the component
        if (
          wrapperRefMenu.current &&
          !wrapperRefMenu.current.contains(event.target as Node)
        ) {
          if (setIsOpenMenu) {
            const updatedMenuState = isOpenMenus && isOpenMenus.map(() => false)
            if (updatedMenuState) {
              setIsOpenMenu(updatedMenuState)
            }
          }
        }
      }
      document.addEventListener('mousedown', handleOutsideClick)
      return () => {
        document.removeEventListener('mousedown', handleOutsideClick)
      }
    }, [])
  
    return (
      <>
        <div  ref={wrapperRefScrollMenu} className={`${type == 'table' ? 'absolute' : 'relative'}`}>
          {children}
          {isOpen && (
            <div
             
              className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl z-10 p-1 cursor-pointer"
            >
              <div className="py-1">
                {items?.map((item, index) => (
                  <div
                  
                    key={index}
                    onClick={item.onClick}
                    
                    className={`${item.display==false?"hidden":"flex"} flex gap-2 px-4 py-3 hover:bg-gray-100 w-full rounded-lg group`}
                  >
                    {item?.icon && (
                      <Icon
                        name={item?.icon}
                        width={16}
                        height={16}
                        strokeWidth={1}
                        stroke={item?.iconColor ? item?.iconColor : '#02698C'}
                      />
                    )}
                    <p
                      className={`group-hover:text-text2 text-xs hover:font-medium font-medium ${item?.textColor ? item?.textColor : 'text-text1'}`}
                    >
                      {item.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </>
    )
  }
  
  export default DashboardMenu
  